import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header group={null} version={null} />
      <div style={{ backgroundColor: "#fff", minHeight: "100vh", padding: "40px 20px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ marginBottom: "30px" }}>
            <button
              onClick={() => navigate(-1)}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                color: "#007bff",
                textDecoration: "underline",
                marginBottom: "20px",
              }}
            >
              ← Back
            </button>
            <h1 className="mission_heading" style={{ marginBottom: "30px", textAlign: "left" }}>
              Refund Policy
            </h1>
          </div>

          <div>
            <p style={{ fontFamily: "Montserrat", fontWeight: 500, fontSize: "16px", lineHeight: "24px", color: "#555582" }}>
              We do not offer refund or exchange of any products or services
              once purchased.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default RefundPolicy;




